import styled from 'styled-components';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import updaetQuery from '@utils/updaetQuery';
import { Spacings } from '@styles/index';

const StyledAvatar = styled(LazyLoadImage)`
  border-radius: ${({ $circular }) =>
    $circular ? '50%' : Spacings.SPACING_2B};
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  object-fit: cover;
  cursor: pointer;
  user-drag: none;
  user-select: none;
`;

const Picture = styled.picture`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`;

const Avatar = (props) => {
  const { src, className, circular, size, ...rest } = props;
  const webp = updaetQuery(src, 'fm', 'webp');
  const imageType = src?.includes('png') ? 'png' : 'jpg';
  return (
    <Picture size={size}>
      <source srcSet={webp} type="image/webp" />
      <source srcSet={src} type={`image/${imageType}`} />
      <StyledAvatar
        {...rest}
        $circular={circular}
        visibleByDefault
        src={src}
        className={className}
        height={size}
        width={size}
      />
    </Picture>
  );
};

Avatar.propTypes = {
  src: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  circular: PropTypes.bool
};

Avatar.defaultProps = {
  height: 'initial',
  width: 'initial',
  size: null,
  className: '',
  circular: false
};

export default Avatar;
